import { BreakpointsPoints } from '~types/Breakpoints.types';

export const breakpoints = {
  [BreakpointsPoints.Xxs]: 0,
  [BreakpointsPoints.Xs]: 425,
  [BreakpointsPoints.Sm]: 768,
  [BreakpointsPoints.Md]: 1024,
  [BreakpointsPoints.Lg]: 1280,
  [BreakpointsPoints.Xl]: 1440,
  [BreakpointsPoints.Xxl]: 1680,
};
